export default "__VITE_ASSET__9b837f90__"